"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _SlideItem = _interopRequireDefault(require("./SlideItem.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Bitmaps = (0, _component.default)(function () {
  return import("./Bitmaps");
});
var Image = (0, _component.default)(function () {
  return import("./Image");
});
var Texts = (0, _component.default)(function () {
  return import("./Texts");
});
var Video = (0, _component.default)(function () {
  return import("./Video");
});

var SlideItem = function SlideItem(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
      bitmaps = _ref.bitmaps,
      hideTexts = _ref.hideTexts,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      playAnimation = _ref.playAnimation,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      stopAnimation = _ref.stopAnimation,
      texts = _ref.texts,
      textStyles = _ref.textStyles,
      webpFallback = _ref.webpFallback;

  var _ref2 = media || {},
      mediaType = _ref2.mediaType;

  var css = (0, _SlideItem.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.root, "mco-animation-01__slide-item", _defineProperty({
      "mco-animation-01__slide-item--active": show
    }, css.show, show))
  }, mediaType === "image" && /*#__PURE__*/_react.default.createElement(Image, {
    absoluteMediaURLs: absoluteMediaURLs,
    media: media,
    mediaFormats: mediaFormats,
    webpFallback: webpFallback
  }), ["youtubevideo", "videofile"].indexOf(mediaType) > -1 && /*#__PURE__*/_react.default.createElement(Video, {
    absoluteMediaURLs: absoluteMediaURLs,
    media: media,
    playAnimation: playAnimation,
    show: show,
    stopAnimation: stopAnimation,
    type: mediaType
  }), !(0, _isEmpty.default)(texts) && !hideTexts && /*#__PURE__*/_react.default.createElement(Texts, {
    texts: texts,
    textStyles: textStyles
  }), !(0, _isEmpty.default)(bitmaps) && /*#__PURE__*/_react.default.createElement(Bitmaps, {
    bitmaps: bitmaps
  }));
};

var _default = SlideItem;
exports.default = _default;